// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-value{padding:10px 25px;font-weight:400;display:grid;grid-template-rows:1fr 1fr}
`, "",{"version":3,"sources":["webpack://./src/CensusCoolerHistoryList/components/CensusLabelValue/styles.scss"],"names":[],"mappings":"AAAA,aACE,iBAAkB,CAClB,eAAgB,CAChB,YAAa,CACb,0BAA2B","sourcesContent":[".label-value {\n  padding: 10px 25px;\n  font-weight: 400;\n  display: grid;\n  grid-template-rows: 1fr 1fr;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
